// extracted by mini-css-extract-plugin
export default {"footerBg":"z-z","footerTopLinks":"A-z","footerFeedback":"B-z","footerSocial":"C-z","footerLegalLinks":"D-z","footerIconCards":"E-z","footerBotCopy":"F-z"};